import { createApi } from '@reduxjs/toolkit/query/react';
import { IMenu } from '../../../types/Menu';
import { createBaseQueryWithAuth } from '../../../utils/baseQuery';

const URL_PREFIX = '/menu-hierarchy';
const METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const sidebarApi = createApi({
  reducerPath: 'sidebarApi',
  baseQuery: createBaseQueryWithAuth(`${process.env.REACT_APP_API_URL}`),
  endpoints: (builder) => ({
    getMenuTree: builder.query<IMenu, any>({
      query: () => ({
        url: `${URL_PREFIX}/tree`,
        method: METHODS.GET,
      }),
    }),
  }),
});

export const { useGetMenuTreeQuery } = sidebarApi;
